/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2023 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function PackageTimingsSearchViewController(
	_: JS5Object,
	$scope: JS5Object,
	uiGridConstants: JS5Object,
	PackageUtilService: JS5Object,
	PackageResourceFactory: JS5Object,
	ModalService: JS5Object,
	NotificationService: JS5Object,
) {
	this.selectedItems = [];

	const parseTimingsData = (timings: JS5Object) => {
		this.pkgTimings = timings;
		let timingsData = [];
		let commBlacks = timings.commercialBlackTimings.map((commercialTiming: JS5Object) => {
			return {id: commercialTiming.id, description: 'Commercial Black', startTC: commercialTiming.startTC,
				endTC: commercialTiming.endTC, durationTC: commercialTiming.durationTC};
		});
		if(timings.programTiming) {
			timingsData.push({description: 'Program Start', startTC: timings.programTiming.startTC});
			Array.prototype.push.apply(timingsData, commBlacks);
			timingsData.push({description: 'Program End', startTC: timings.programTiming.endTC, durationTC: timings.programTiming.durationTC});
		} else {
			Array.prototype.push.apply(timingsData, commBlacks);
		}
		this.currentGridOptions.data = timingsData;
		PackageUtilService.tabLoadDataFunction();
		$scope.$emit('server-busy', {working: false});
	};

	const getSearchData = () => {
		$scope.$emit('server-busy', {working: true});
		PackageResourceFactory.getTimings({id: this.packageObject.id}).$promise.then(parseTimingsData);
	};

	const fileUploadModalHandler = (fileUploadObject: JS5Object) => {
		$scope.$emit('server-busy', {working: true});
		PackageResourceFactory.uploadTimings({id: this.packageObject.id}, fileUploadObject).$promise.then(parseTimingsData);
	};

	this.toggleRows = (evt: JS5Object) => {
		if(this.gridApi.selection.selectAll) {
			this.gridApi.selection.clearSelectedRows(evt);
			this.gridApi.selection.selectAll = false;
		} else {
			this.gridApi.selection.selectAllVisibleRows(evt);
			this.gridApi.selection.selectAll = true;
		}
		this.selectedItems = this.gridApi.selection.getSelectedRows();
	};

	this.gridRowSelectionChangedHandler = (row: JS5Object, event: JS5Object) => {
		let timing = row.entity;
		if (row.isSelected) {
			this.selectedItems.push(timing);
			if(timing.description === 'Program Start' && event) {
				this.gridApi.selection.selectRow(this.currentGridOptions.data[this.currentGridOptions.data.length - 1]);
			} else if(timing.description === 'Program End' && event) {
				this.gridApi.selection.selectRow(this.currentGridOptions.data[0]);
			}
		} else {
			let index = this.selectedItems.indexOf(timing);
			this.selectedItems.splice(index, 1);
			if(timing.description === 'Program End' && event) {
				this.gridApi.selection.unSelectRow(this.currentGridOptions.data[0]);
			} else if(timing.description === 'Program Start' && event) {
				this.gridApi.selection.unSelectRow(this.currentGridOptions.data[this.currentGridOptions.data.length - 1]);
			}
		}
	};

	this.rowDoubleClicked = (row: JS5Object) => {
		let timing = row.entity;
		if(timing.description.indexOf('Program') > -1) {
			ModalService.showPkgTimingEditModal(this.pkgTimings.programTiming, this.saveTiming);
		} else {
			let commercialTiming = this.pkgTimings.commercialBlackTimings.filter((commercialTiming: JS5Object) => {
				return commercialTiming.id === timing.id;
			})[0];
			commercialTiming.description = 'Commercial Black';
			ModalService.showPkgTimingEditModal(commercialTiming, this.saveTiming);
		}
	};

	this.gridColumns = [
		{
			name: 'checkMarkRowHeaderCol',
			field: 'checkMark',
			width: 30,
			enableColumnMenu: false,
			enableSorting: false,
			enableColumnResizing: false,
			cellTemplate: 'components/visual/grid/check-mark-template.html',
			headerCellTemplate: 'components/visual/grid/header-check-mark-template.html'
		},
		{
			field: 'description',
			displayName: 'Description',
			minWidth: 250,
			enableSorting: false,
			cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
		},
		{
			field: 'startTC',
			displayName: 'Timecode In *',
			sort: {
				direction: uiGridConstants.ASC,
				priority: 0
			},
			enableSorting: false,
			cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
		},
		{
			field: 'endTC',
			displayName: 'Timecode Out *',
			enableSorting: false,
			cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
		},
		{
			field: 'durationTC',
			displayName: 'Duration *',
			enableSorting: false,
			cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
		}
	];


	this.currentGridOptions = {
		selectionRowHeaderColName: 'checkMarkRowHeaderCol',
		rowSelection: true,
		enableRowHeaderSelection: false,
		enableSelectAll: true,
		enableColumnResizing: true,
		enablePaginationControls: false,
		useExternalPagination: true,
		enableColumnMenus: false,
		enableFullRowSelection: true,
		enableHorizontalScrollbar: 0,
		enableVerticalScrollbar: 0,
		rowHeight: 26,
		multiSelect: true,
		columnDefs: this.gridColumns,
		rowTemplate: '<div ng-dblclick="grid.appScope.searchController.rowDoubleClicked(row)" ' +
		'ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" ' +
		'ng-class="row.entity.hidden ? \'ui-grid-cell-hidden\' : \'\'" class="ui-grid-cell" ui-grid-cell> ' +
		'</div>',
		onRegisterApi: (gridApi: JS5Object) => {
			this.gridApi = gridApi;
			gridApi.selection.on.rowSelectionChanged($scope, this.gridRowSelectionChangedHandler);
		}
	};

	$scope.$watch(() => {
		return this.timingsSearchForm;
	}, (newValue: JS5Object) => {
		if (newValue) {
			PackageUtilService.editorForm = this.timingsSearchForm;
		}
	});

	this.$onDestroy = () => {
		PackageUtilService.tabNewFunction = null;
		PackageUtilService.tabDeleteFunction = null;
	};

	this.saveTiming = (timingToSave: JS5Object) => {
		if(timingToSave.description === 'Commercial Black') {
			if(_.get(this.packageObject, 'primaryAcceptTemplateMember.acceptProfile.videoMasterType.programTimingRequired') && !this.pkgTimings.programTiming) {
				NotificationService.createWarningNotification('Program Start/End needs to be set before adding Commercial Black timings');
				return;
			}
			if(this.pkgTimings.programTiming && (timingToSave.startTC < this.pkgTimings.programTiming.startTC || timingToSave.endTC > this.pkgTimings.programTiming.endTC)) {
				NotificationService.createWarningNotification('Commercial Black Timing cannot be outside the range of Program Start/End');
				return;
			}
		}

		$scope.$emit('server-busy', {working: true});
		if(!timingToSave.id) {
			if(timingToSave.description === 'Commercial Black') {
				this.pkgTimings.commercialBlackTimings.push(timingToSave);
			} else {
				this.pkgTimings.programTiming = timingToSave;
			}
		}
		PackageResourceFactory.saveTiming({id: this.packageObject.id}, this.pkgTimings).$promise.then(parseTimingsData);
	};

	this.addTiming = () => {
		ModalService.showPkgTimingEditModal(null, this.saveTiming);
	};

	this.deleteSelectedTimings = () => {
		$scope.$emit('server-busy', {working: true});
		angular.forEach(this.selectedItems, (selectedTiming: JS5Object) => {
			if(selectedTiming.description.indexOf('Program') > -1) {
				this.pkgTimings.programTiming = null;
			} else {
				this.pkgTimings.commercialBlackTimings = this.pkgTimings.commercialBlackTimings.filter((timing: JS5Object) => {
					return timing.id !== selectedTiming.id;
				});
			}
		});
		PackageResourceFactory.saveTiming({id: this.packageObject.id}, this.pkgTimings).$promise.then(parseTimingsData);
	};

	this.deleteInvalid = () => {
		return this.selectedItems.length === 0;
	};

	this.timingsUploadBtnHandler = () => {
		let uploadTemplate = {acceptProfile: {fileExtensions: ['csv', 'CSV']}};
		ModalService.showFileUploadModal([uploadTemplate], 'CSV', fileUploadModalHandler);
	};

	this.$onInit = () => {
		PackageUtilService.tabNewFunction = this.addTiming;
		PackageUtilService.tabDeleteFunction = this.deleteSelectedTimings;
		PackageUtilService.tabDeleteInvalid = this.deleteInvalid;
		PackageUtilService.tabUploadFunction = this.timingsUploadBtnHandler;

		getSearchData();
	};
}

angular
	.module('prism-ui.package')
	.component('packageTimingsSearchView', {
		controller: PackageTimingsSearchViewController,
		templateUrl: 'package/editor/components/view/timings/searchView/packagetimings-search-view-template.html',
		bindings: {
			packageObject: '=',
		}
	});
